<template>
  <div>
    <div class="block">
      <span class="demonstration">{{ $t("login.login") }}</span>
      <el-date-picker
        v-model="value1"
        type="datetime"
        placeholder="选择日期时间"
      />
    </div>
    <div class="block">
      <span class="demonstration">带快捷选项</span>
      <el-date-picker
        v-model="value2"
        type="datetime"
        placeholder="选择日期时间"
        align="right"
        :picker-options="pickerOptions"
      />
    </div>
    <div class="block">
      <span class="demonstration">设置默认时间</span>
      <el-date-picker
        v-model="value3"
        type="datetime"
        placeholder="选择日期时间"
        default-time="12:00:00"
      />
    </div>

    <div v-if="false">
      <el-steps :active="3" style="margin-top: 20px" align-center>
        <el-step title="123" icon="el-icon-caret-bottom" class="is-finish">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
          <template
            slot="title"
          >12312sxdfds</template>
        </el-step>
        <!-- <template slot="description">el-icon-edit</template> -->
        <el-step title="123" icon="el-icon-caret-bottom" class="is-finish">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
          <template
            slot="title"
          >12312sxdfds</template>
        </el-step>
        <el-step title="213" icon="el-icon-caret-bottom" class="is-last-finish">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
          <template
            slot="title"
          >12312sxdfds</template>
        </el-step>
        <el-step title icon="el-icon-caret-bottom" class="is-wait">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
        </el-step>
        <el-step title icon="el-icon-caret-bottom" class="is-wait">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
        </el-step>
        <el-step title="步骤 4" icon="el-icon-caret-bottom" class="is-end">
          <template slot="icon">
            <i class="el-icon-caret-bottom el-step-icon" />
          </template>
          <template
            slot="title"
          >Litigation</template>
        </el-step>
      </el-steps>

    </div>
    <div style="background-color:white;">
      <stage-ratio :stage-item-data="stageItemData" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      value1: '',
      value2: '',
      value3: '',
      stageItemData: [
        {
          name: '项目1',
          totalCount: 6,
          children: [
            {
              name: '阶段1',
              count: 2
            }
          ]
        },
        {
          name: '项sdfdfgdfgsgsgsf目1',
          totalCount: 6,
          children: [
            {
              name: '阶sfsdsdfsdfsfa段1',
              count: 2,
              content: 'aaaaaa',
              iconNameArray: ['bbbb', 'cccc']
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 3,
              content: 'bbb',
              iconNameArray: ['adf', 'fdsddfdff', 'afsfd', 'sfdf']
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 1
            },
            {
              name: '阶sfsd33sdf332432sfa段2',
              count: 65654654654232
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 1
            }
          ]
        },
        {
          name: '项sdfdfgdfgsgsgsf目1',
          totalCount: 7,
          children: [
            {
              name: '阶sfsdsdfsdfsfa段1',
              count: 2
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 3
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 6
            },
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 1
            }
          ]
        },
        {
          name: '项sdfdfgdfgsgsgsf目1',
          totalCount: 1,
          children: [
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 1
            }
          ]
        },
        {
          name: '项sdfdfgdfgsgsgsf目1',
          totalCount: 1,
          children: [
            {
              name: '阶sfsdsdfsdfsfa段2',
              count: 1
            }
          ]
        }
      ]
    }
  }
}
</script>
<style>
/* 图标 */
.el-step-icon {
  font-size: 40px;
}

.is-finish .el-step-icon {
  color: red;
}

.is-end .el-step-icon {
  color: #cdd0d4;
}

.el-steps .el-step .el-step__head .el-step__icon {
  width: 30px;
}

.el-steps .el-step.is-wait .el-step__head .el-step__icon {
  display: none;
}

.el-steps .el-step.is-wait .el-step__head .el-step__icon {
  display: none;
}

/* .el-steps .el-step .el-step__head.is-wait .el-step__icon{
  display: none;
} */

/* 标题 */
.el-steps .el-step.is-finish .el-step__main .el-step__title {
  font-size: 16px;
  color: red;
}

.el-steps .el-step.is-last-finish .el-step__main .el-step__title {
  font-size: 16px;
  color: red;
}

.el-steps .el-step.is-end .el-step__main .el-step__title {
  font-size: 16px;
  color: #cdd0d4;
}

/* 连接线 */
.el-steps .el-step .el-step__head .el-step__line {
  height: 4px !important;
}

.el-steps .el-step .el-step__head .el-step__line .el-step__line-inner {
  border-width: 2px !important;
  border-color: red;
}

.el-steps .el-step.is-wait .el-step__head .el-step__line {
  background-color: #cdd0d4;
}

.el-steps .el-step.is-wait .el-step__head .el-step__line .el-step__line-inner {
  border-color: #cdd0d4;
}

.el-steps .el-step.is-last-finish .el-step__head .el-step__line {
  background-color: #cdd0d4;
}
</style>
